var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home mt-2 text-opacity"},[_vm._v("You don't have enough permissions to access this Page.")])}
var staticRenderFns = []

export { render, staticRenderFns }